export interface AzureProviderTokenDto {
  token: string;
  expiresAt: number;
}
